/**
 * Blog Component Theme
 */

export const blogStyles = {
  parts: ['root', 'headerMedia', 'content'],
  baseStyle: {
    root: {
      // Align with global header content rail (see theme/components/project/header.js → content)
      maxWidth: '1440px',
      marginX: 'auto',
      paddingX: {base: '20px', lg: '80px'},
      width: '100%',
    },
    headerMedia: {
      mb: 8,
      mt: {base: 4, md: 'unset'},
      '& img': {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
      },
    },
    content: {
      'py': {base: 8, md: 12},
      sx: {
        '& > .rich-text-content.amb-markup': {
          '& h1,& h2,& h3,& h4,& h5,& h6': {
            lineHeight: '120%',
            '& b, & strong': {
              fontWeight: '500',
              lineHeight: '120%',
            },
          },
          '& ul, & ol': {
            pl: 5,
          },
          '& p, & blockquote': {
            whiteSpace: 'pre-line',
          },
          '& b, & strong, & p b, & p strong': {
            fontWeight: '600',
            color: 'brandColors.greyscale90',
          },
        },
      },
      // Typography (h1–h6, p, blockquote, links) comes from global `.amb-markup` in theme/foundations/styles.js
      '& h1': {
        mt: 8,
        mb: 4,
      },
      '& h2': {
        mt: 8,
        mb: 4,
      },
      '& h3': {
        mt: 6,
        mb: 3,
      },
      '& h4': {
        mt: 6,
        mb: 3,
      },
      '& h5': {
        mt: 4,
        mb: 2,
      },
      '& h6': {
        mt: 4,
        mb: 2,
      },
      '& p': {
        mb: 4,
      },
      '& ul, & ol': {
        pl: 6,
        mb: 4,
      },
      '& li': {
        mb: 2,
      },
      // Embedded Image captions: Chakra-wrapped tags from jsxParser need explicit overrides
      '& .embedded-entry-block .component--image .amb-markup': {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
      },
      '& .embedded-entry-block .component--image .rich-text-content.amb-markup p.chakra-text, & .embedded-entry-block .component--image .rich-text-content.amb-markup .chakra-text': {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
        mb: 0,
      },
      '& .embedded-entry-block .component--image .rich-text-content.amb-markup a.chakra-link, & .embedded-entry-block .component--image .rich-text-content.amb-markup .chakra-link, & .embedded-entry-block .component--image .rich-text-content.amb-markup a': {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
      },
    },
  },
};
